export const BASE_URL = "https://beta.api.oksensay.com";
//export const BASE_URL = "https://infallible-allen-6e625c.netlify.app";
// export const BASE_URL = "http://localhost:8088";